import { cx } from '@onbeam/business-styled-system/css';
import { text } from '@onbeam/business-styled-system/patterns';
import { SVGTextElementAttributes } from 'react';

export const IntroSectionText = ({
  className,
  ...props
}: SVGTextElementAttributes<SVGTextElement>) => (
  <text
    className={cx(
      text({
        style: 'headline-lg',
        fill: 'mono.primaryBg',
        fontSize: '37px',
        letterSpacing: '-0.2px',
        sm: {
          letterSpacing: '-0.5px',
          fontSize: '42px',
        },
      }),
      className,
    )}
    {...props}
  />
);
